import { render } from "./CustomerTerms.vue?vue&type=template&id=66bbbc01&scoped=true&ts=true&lang=pug"
import script from "./CustomerTerms.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerTerms.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerTerms.vue?vue&type=style&index=0&id=66bbbc01&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bbbc01"]])

export default __exports__